import script from "./ArticleEditor.vue?vue&type=script&setup=true&lang=js"
export * from "./ArticleEditor.vue?vue&type=script&setup=true&lang=js"

import "./ArticleEditor.vue?vue&type=style&index=0&id=14356508&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-14356508"]])

export default __exports__